import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getCoachingCmsListRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_LIST,
    params: params,
  });
};

export const getCoachingCmsCoursesRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_COURSES,
    params: params,
  });
};

export const getCoachingCmsExamsRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_EXAMS,
    params: params,
  });
};

export const getCoachingCmsSubjectsRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_SUBJECTS,
    params: params,
  });
};

export const getCoachingCmsCourseListRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_COURSE_LIST,
    params: params,
  });
};

export const postCmsCoachingOverviewRepo = (data) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_CMS_COACHING_OVERVIEW_API,
    data: data,
  });
};

export const getCmsCoachingLocationRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_LOCATION,
    params: params,
  });
};

export const patchCmsCoachingOverviewRepo = (params, id) => {
  if (params.is_delete) {
    delete params.is_delete;
    return axios({
      baseURL:
        ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
      method: "DELETE",
      url: Urls.PATCH_CMS_COACHING_OVERVIEW + params.coaching_id,
      params: params,
    });
  } else {
    if (id) {
      return axios({
        baseURL:
          ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: "POST",
        url: Urls.PATCH_CMS_COACHING_OVERVIEW + id,
        data: params,
      });
    }
  }
};

export const getCoachingCmsMediaDropdownRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_MEDIA_DROPDOWN_API,
    params: params,
  });
};

export const getCoachingCmsMediaRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COACHING_MEDIA_API,
    params: params,
  });
};

export const UpdateCmsCoachingMediaRepo = (params, body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.UPDATE_CMS_COACHING_MEDIA_API + params.coaching_id,
    params: params,
    data: body,
  });
};

export const UpdateCmsCoachingCourseRepo = (params, body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.UPDATE_CMS_COACHING_COURSE_API,
    // params.coaching_id +
    // "/" +
    // params.course_id,
    params: params,
    data: body,
  });
};
export const postCmsCoachingTopperRepo = (data) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_CMS_COACHING_TOPPER_API,
    data: data,
  });
};

export const patchCmsCoachingTopperRepo = (params, data) => {
  if (params.is_delete) {
    delete params.is_delete;
    return axios({
      baseURL:
        ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
      method: "DELETE",
      url:
        Urls.PATCH_CMS_COACHING_TOPPER_API +
        `${params.coaching_id}/` +
        `${params.topper_id}`,
      params: params,
      data: data,
    });
  } else {
    return axios({
      baseURL:
        ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
      method: "POST",
      url:
        Urls.PATCH_CMS_COACHING_TOPPER_API +
        `${params.coaching_id}/` +
        `${params.topper_id}`,
      params: params,
      data: data,
    });
  }
};

export const getCoachingNameRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_COACHING_NAME_API,
    params: params,
  });
};

export const postCmsCoachingCourseRepo = (body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_COACHING_COURSE_API,
    data: body,
  });
};
export const DeleteCmsCoachingCourseRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "DELETE",
    url: Urls.POST_COACHING_COURSE_API,
    params: params,
  });
};

export const getCoachingToppersRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_COACHING_TOPPERS_API,
    params: params,
  });
};

export const getCoachingInstituteRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_COACHING_INSTITUTE_API,
    params: params,
  });
};

export const postCoachingInstituteRepo = (body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_COACHING_INSTITUTE_API,
    data: body,
  });
};

export const patchCoachingInstituteRepo = (params, body) => {
  if (params.is_delete) {
    delete params.is_delete;
    return axios({
      baseURL:
        ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
      method: "DELETE",
      url:
        Urls.UPDATE_COACHING_INSTITUTE_API +
        `${params.coaching_id}/` +
        `${params.institute_id}`,
      params: params,
    });
  } else {
    return axios({
      baseURL:
        ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
      method: "POST",
      url:
        Urls.UPDATE_COACHING_INSTITUTE_API +
        `${params.coaching_id}/` +
        `${params.institute_id}`,
      params: params,
      data: body,
    });
  }
};

export const getCoachingDistrictRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_COACHING_DISTRICT_LIST_API,
    params: params,
  });
};

export const deleteCoachingOtherMediaRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "DELETE",
    url: Urls.DELETE_COACHING_OTHER_MEDIA_API,
    params: params,
  });
};

export const postCmsCoachingMediaImageRepo = (params, body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_COACHING_MEDIA_IMAGE_API,
    data: body,
    params: params,
  });
};

export const postCmsCoachingCoursePublishRepo = (params, body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.POST_COACHING_COURSE_PUBLISH_API,
    data: body,
    params: params,
  });
};

export const postCmsCoachingPublishRepo = (params, body) => {
  return axios({
    baseURL:
      ServiceUrls.COACHING_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.POST_COACHING_PUBLISH_API,
    data: body,
    params: params,
  });
};


